"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextBoldSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M6.16,3.19h9q5.26,0,7.81,1.56a5.29,5.29,0,0,1,2.55,4.86,6.15,6.15,0,0,1-1.11,3.71,5,5,0,0,1-2.93,2v.17A6,6,0,0,1,25,17.59,6.4,6.4,0,0,1,26,21.44,6.59,6.59,0,0,1,23.4,27a11.5,11.5,0,0,1-7.19,2h-10Zm7,9.9h2.1a3.74,3.74,0,0,0,2.32-.62,2.13,2.13,0,0,0,.82-1.83c0-1.45-1.09-2.17-3.28-2.17h-2Zm0,5.1v5.42h2.45c2.18,0,3.27-.91,3.27-2.75a2.36,2.36,0,0,0-.88-2,4,4,0,0,0-2.53-.69Z"/>';
var TextBoldSVG = function TextBoldSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.TextBoldSVG = TextBoldSVG;
TextBoldSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(TextBoldSVG);
exports.default = _default;